import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFormatLineHeight = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M10 4.75H6.75a1 1 0 0 0-1 1v2m4.25-3h3.25a1 1 0 0 1 1 1v2m-4.25-3v10.5m0 0H7.75m2.25 0h2.25M17 1.75H2.5M17 18.25H2.5"
	})]
});
const ForwardRef = forwardRef(SvgFormatLineHeight);
export { ForwardRef as ReactComponent };
